import React from "react";
import "../Css/Header.css";

const Header = () => {
  return (
    <>
        <div className={"logo"}>
            Welcome to Web Componentify! 🙌
        </div>
    </>
  );
};

export default Header;
